import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

export default function CapturePasswordEntered(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    // updating the modal property
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "georgew")
    .update([ "password" ], "12345678")
    .update([ "userIDValOnChange" ], "georgew")
    .update([ "passwordValOnChange" ], "12345678")
    .submit();

    return <LoginPage data={ data } />
}
